import { useTranslation } from "react-i18next";
import { default as version } from "../../../../../package.json";
import { multiUserApi } from "../../../../shared/utils/multiUserFunctions";
import { LanguageSelect } from "../../../i18nSelect";
import { AppButton } from "../../../../shared/components/AppButton";
import { PlusIcon } from "../../../../shared/icons/PlusIcon";
import { TPopoverIds } from "../../../../app/state/popoverSlice/types";
import { StaticTokenButton } from "../StaticTokenButton";
import { LogoutIcon } from "../../../../shared/icons/LogoutIcon";
import { TUserAccountActions } from "../../types";
import { AppPopover } from "../../../AppPopover";
import { UserSelect } from "./UserSelect";
import { AuthUserType } from "../../../../services/api/methodsTypes";
import { usePopoverSelectors } from "../../../../app/state/popoverSlice/hook/use-popover-selectors";
import styles from "./styles.module.css";

interface Props {
  popoverActions: (type: TUserAccountActions) => void;
  closePopover: (id: TPopoverIds) => void;
}

export const UserAccountPopover = ({ popoverActions, closePopover }: Props) => {
  const userAccount = usePopoverSelectors("user_account_popover");
  const { t } = useTranslation();

  const handleActionPopover = (type: TUserAccountActions) => {
    popoverActions(type);
    closePopover("user_account_popover");
  };

  return (
    <AppPopover
      open={userAccount.isOpen}
      onClose={() => closePopover("user_account_popover")}
      anchorReference={"anchorPosition"}
      anchorPosition={{
        left: (userAccount.position?.x ?? 0) + 35,
        top: (userAccount.position?.y ?? 0) + 35,
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      className={styles["popover"]}
      contentClassName={styles["popover-body"]}
    >
      <UserSelect
        userList={multiUserApi.parseToArray()}
        user={multiUserApi.getActiveUser() as AuthUserType}
      />
      <LanguageSelect />
      <AppButton
        buttonType="text"
        onClick={() => handleActionPopover("add_user")}
        icon={<PlusIcon />}
        className={styles["button"]}
      >
        {t("header.add_user_button")}
      </AppButton>
      <StaticTokenButton
        openCreateStatic={() => handleActionPopover("static_token")}
        className={styles["button"]}
      />
      <div className={styles.divider}></div>
      <AppButton
        onClick={() => handleActionPopover("logout")}
        buttonType="text"
        icon={<LogoutIcon />}
        className={styles["button"]}
      >
        Выйти
      </AppButton>
      <div className={styles.version}>{version.version}-dev</div>
    </AppPopover>
  );
};
